import { render, staticRenderFns } from "./ModalAsignarDisposicionActiva.vue?vue&type=template&id=57c8a449&"
import script from "./ModalAsignarDisposicionActiva.vue?vue&type=script&lang=js&"
export * from "./ModalAsignarDisposicionActiva.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports